import angular from 'angular';
import copy from 'app/constants';
import {
  ssDialogService,
  loaderService,
  controlDataService
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-control-dialog.controller';
import template from './edit-control-dialog.html';
import nameMessagesTpl from './messages/control.messages.html';
import controlRiskNameMessagesTpl from './messages/control-risk.messages.html';
import controlTypeNameMessagesTpl from './messages/control-type.messages.html';
import validator, { name as validatorName } from './messages/control-unique-name.validator.directive';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';
require('ng-file-upload/dist/ng-file-upload-shim');// Loads itself

export class dialogService {
  getOptions($event, {
    control,
    controlTypes,
    risks,
    risk,
    addCallback,
    updateCallback,
    controlResults,
    controlPreventiveEffectivenesses,
    controlDetectiveEffectivenesses,
    controlCorrectiveEffectivenesses,
    controlAdministrativeNatures,
    controlPhysicalNatures,
    controlTechnicalNatures,
    controlPrimaryControlTypes,
    controlCompensatingControlTypes,
    controlReviewSchedules,
    controlReviewTypes,
    updateCallBack
  }) {
    return {
      controller,
      controllerAs: 'editControlDialogVM',
      locals: {
        control,
        controlTypes,
        risks,
        risk,
        addCallback,
        updateCallback,
        controlResults,
        controlPreventiveEffectivenesses,
        controlDetectiveEffectivenesses,
        controlCorrectiveEffectivenesses,
        controlAdministrativeNatures,
        controlPhysicalNatures,
        controlTechnicalNatures,
        controlPrimaryControlTypes,
        controlCompensatingControlTypes,
        controlReviewSchedules,
        controlReviewTypes,
        updateCallBack
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.controlAdministration.editControlDialog', [
  ngFileUpload,
  ssDialogService,
  loaderService,
  controlDataService,
  copy,
  alerts,
])
  .service('editControlDialog', dialogService)
  .directive(validatorName, validator)
  .run(($templateCache) => {
    $templateCache.put('control.messages.html', nameMessagesTpl);
    $templateCache.put('control.risk.messages.html', controlRiskNameMessagesTpl);
    $templateCache.put('control.type.messages.html', controlTypeNameMessagesTpl);
  })
  .name;

console.log('app.components.admin.controlAdministration.editControlDialog created');
